import NdisClaimNewContainer from "./NdisClaimNew.container";

export default NdisClaimNewContainer;
